import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import DateInput from './input';
import Tooltip from 'components/tooltip';
import { Form, InputGroup } from 'react-bootstrap-5';

import './styles.scss';

export default function ApexDateFormGroup({
  asInputGroup,
  className,
  disabled,
  disabledMessage,
  hasError,
  inputClassName,
  label,
  name,
  required,
  ...props
}) {
  const groupClassName = classNames('apex-date-form-group form-group', className, {
    'has-error': hasError || true,
    required: required,
  });

  let formGroup;
  if (asInputGroup) {
    formGroup = (
      <InputGroup className="overflow-visible">
        <InputGroup.Text className="bg-light">
          {label}
        </InputGroup.Text>
        <div className="form-input-container flex-fill">
          <DateInput
            className={classNames('form-control', inputClassName)}
            disabled={disabled}
            name={name}
            {...props}
          />
        </div>
      </InputGroup>
    );
  } else {
    formGroup = <>
      <Form.Label>
        {label}
      </Form.Label>
      <div className="form-input-container">
        <DateInput
          className={classNames('form-control', inputClassName)}
          disabled={disabled}
          name={name}
          {...props}
        />
      </div>
    </>;
  }

  formGroup = <div className={groupClassName}>{formGroup}</div>;

  if (disabled && disabledMessage) {
    formGroup = <Tooltip content={disabledMessage}>{formGroup}</Tooltip>;
  }

  return formGroup;
}

ApexDateFormGroup.propTypes = {
  asInputGroup: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  hasError: PropTypes.bool,
  inputClassName: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string
};
